import api from "./api";

export const reorderTask = (taskId, newSortOrder) => {
  return api.put(`/tasks/${taskId}/reorder`, { newSortOrder });
};

export const normalizeSortOrder = () => {
  return api.post("/tasks/normalize-order");
};

export default {
  reorderTask,
  normalizeSortOrder
};
